import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { serverDomain } from "../config";
import "./TopBar.css";

const TopBar = ({ pageTitle }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userBalance, setUserBalance] = useState("");
  const [userHold, setUserHold] = useState(0);
  const [userPercentage, setUserPercentage] = useState(50);

  const navigate = useNavigate();
  const ddRef = useRef(null);

  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark" || savedTheme === "light") return savedTheme;
  
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  };
  
  const [theme, setTheme] = useState(getInitialTheme);
  
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${serverDomain}/api/settings/profile`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          if (response.status === 401) handleLogout();
          return;
        }

        const data = await response.json();
        setUserEmail(data?.user?.email || "");
        setUserPercentage(Number(data?.user?.percentage ?? 50));
      } catch (e) {
        console.error("Ошибка загрузки профиля:", e);
      }
    };

    const fetchHold = async () => {
      try {
        const res = await fetch(`${serverDomain}/api/settings/user_hold`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        setUserHold(Number(data?.hold ?? 0));
      } catch (e) {
        console.error("Ошибка загрузки холда:", e);
      }
    };

    const fetchBalance = async () => {
      try {
        const response = await fetch(`${serverDomain}/api/settings/user_balance`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) return;
        const data = await response.json();
        setUserBalance(String(data?.balance ?? ""));
      } catch (e) {
        console.error("Ошибка загрузки баланса:", e);
      }
    };

    fetchUserData();
    fetchBalance();
    fetchHold();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ddRef.current) return;
      if (!ddRef.current.contains(e.target)) setUserDropdownOpen(false);
    };
    const onEsc = (e) => e.key === "Escape" && setUserDropdownOpen(false);

    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleSettings = () => navigate("/settings");

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="top-bar fl-topbar">
      <div className="fl-topbar__inner">
        <div className="fl-topbar__left">
          <div className="fl-brand" onClick={() => navigate("/statistics")} role="button" tabIndex={0}>
            <span className="fl-brand__logo">❤</span>
            <span className="fl-brand__name">FL-Dating.Su</span>
          </div>

          {pageTitle ? <div className="fl-topbar__title">{pageTitle}</div> : null}
        </div>

        <div className="fl-topbar__center">
          <div className="fl-balance">
            <div className="fl-balance__row">
              <span className="fl-balance__label">Баланс:</span>
              <b className="fl-balance__value">{userBalance || "0"} RUB</b>
            </div>
            <div className="fl-balance__sub">(Холд: {Number(userHold || 0).toFixed(2)} RUB)</div>
          </div>

          <div className="fl-rate" title="Ставка">
            {userPercentage}%
          </div>
        </div>

        <div className="fl-topbar__right">
          <button
            className="fl-icon-btn fl-theme-toggle"
            type="button"
            onClick={toggleTheme}
            title={theme === "dark" ? "Светлая тема" : "Тёмная тема"}
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>

          <a className="fl-icon-btn" href="https://t.me/fl_assistance" target="_blank" rel="noreferrer" title="Менеджер">
            ✈️
          </a>
          <a className="fl-icon-btn" href="https://t.me/fldating" target="_blank" rel="noreferrer" title="Канал">
            📢
          </a>

          <div className="fl-user" ref={ddRef}>
            <button
              className="fl-icon-btn fl-icon-btn--solid"
              onClick={() => setUserDropdownOpen((v) => !v)}
              title="Профиль"
              type="button"
            >
              👤
            </button>

            {userDropdownOpen && (
              <div className="fl-dd">
                <div className="fl-dd__head">
                  <div className="fl-dd__email">{userEmail || "User"}</div>
                </div>
                <button className="fl-dd__item" onClick={handleSettings} type="button">
                  Профиль
                </button>
                <button className="fl-dd__item fl-dd__item--danger" onClick={handleLogout} type="button">
                  Выйти
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;